module.exports = __webpack_public_path__ + "img/clean-h.b7656820.svg";